<template>
  <div class="campaign-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header :title="`${campaignId ? 'Editar' : 'Cadastrar'}`">
      <button v-app-button.icon-left.clear v-app-back-button="{ name: 'campaign.index' }">
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>
    <app-card>
      <campaign-form @submit="onSubmit" :id="campaignId" :errors="errors" :saving="isSaving"></campaign-form>
    </app-card>
  </div>
</template>

<script>
import CampaignForm from '@/components/Forms/CampaignForm.vue';
import CampaignService from '@/services/campaign.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'campaign-form-page',
  mixins: [ToastMixin],
  components: {
    CampaignForm,
  },
  data: () => {
    return {
      campaignId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      !this.campaignId && this.save(data);
      this.campaignId && this.update(this.campaignId, data);
    },
    save(data) {
      this.isSaving = true;
      CampaignService.save(data)
        .then(() => {
          this.toastify('Campanha cadastrada com sucesso!');
          this.$router.push({ name: 'campaign.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Campanha',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      CampaignService.update(id, data)
        .then(() => {
          this.toastify('Campanha atualizada com sucesso!');
          this.$router.push({ name: 'campaign.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;
          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Campanha',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.campaignId = this.$route.params.id;
  },
};
</script>

<style lang="scss" scoped></style>
